// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"419a5d54","767":"fa3ec887"}[chunkId] + ".chunk.js";
};